<template>
  <el-dialog :title="$t('detalhe')" :visible.sync="dialog"  width="50%" :fullscreen="false" :close-on-click-modal="false" v-loading="loading">
    <el-form :model="form">
      <el-row :gutter="5">
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
          <el-form-item :label="$t('protocolo')">
            <el-input v-model="protocol"  disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-form-item :label="$t('motivo')">
            <el-input v-model="form.description" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="7">
          <el-form-item :label="$t('tipo')">
            <el-input v-model="form.manifest" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="5">
          <el-form-item :label="$t('ultimo-evento')">
            <el-input v-model="form.event" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-form-item :label="$t('status')">
            <el-input v-model="form.status" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-form-item :label="$t('situacao')">
            <el-input v-model="form.situation" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item :label="$t('resposta')">
            <el-input type="textarea" rows="8" v-model="form.message" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="close">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { RequestInfoService } from "@/services/customers/request.info.services";
export default {
  name: 'RequestInfoDetail',
  data() {
    return {
      protocol: '',
      dialog: false,
      loading: false,
      form: {
        message: '',
        description: '',
        manifest: '',
        evemt: '',
        status: '',
        situation: '',
      }
    }
  },
  methods: {
    fetch() {
      const vm = this;
      vm.loading = true;
      RequestInfoService.detail(
        vm.protocol,
      )
        .then((response) => {
          console.log('response', response)
          vm.form = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => vm.loading = false);
      
      return this.filter;
    },
    open(protocol) {
      const vm = this;
      vm.dialog = true;
      vm.protocol = protocol;
      vm.fetch();
    },
    close() {
      const vm = this;
      vm.dialog = false;
    },
  }
}
</script>